import { render, staticRenderFns } from "./TransferMoney.vue?vue&type=template&id=079c58d2&scoped=true"
import script from "./TransferMoney.vue?vue&type=script&lang=js"
export * from "./TransferMoney.vue?vue&type=script&lang=js"
import style0 from "./TransferMoney.vue?vue&type=style&index=0&id=079c58d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c58d2",
  null
  
)

export default component.exports